import { Box } from "@outschool/backpack";
import { SystemStyleObject } from "@styled-system/css";
import React from "react";

export default function SidebarCard({
  sx,
  children,
}: React.PropsWithChildren<{ sx?: SystemStyleObject }>) {
  return (
    <Box
      flex
      sx={{
        flexDirection: "column",
        borderRadius: "16px",
        padding: "20px",
        border: "1px solid #F0F0F0",
        boxShadow:
          "0px 1px 4px rgba(0, 0, 0, 0.04), 0px 0px 8px rgba(0, 0, 0, 0.04)",
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
